import NotFound from './pages/404NotFound/404';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Services from './pages/services/Services';
import Contact from './pages/contact/Contact';
import Layout from './components/layout/Layout';
import TermsAndConditions from './pages/policiesAndConditions/TermsAndConditions';
import RefundPolicy from './pages/policiesAndConditions/Refund';
import Desclaimer from './pages/policiesAndConditions/Desclaimer';
import PrivacyPolicy from './pages/policiesAndConditions/Privacy';
import DownloadApps from './pages/download/DownloadApps';
import FeedbackSurvey from './pages/feedback/FeedbackSurvey';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';

const LegacyIndexRoute = () => {
    const { hash } = useLocation();
    const legacyHashPath = hash.replace(/^#\/?/, '/');

    if (legacyHashPath === '/mobile-app-privacy-policy') {
        return <Layout><PrivacyPolicy /></Layout>;
    }

    return <NotFound />;
};

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
    {/* Home */}
    <Route path='/' element={<Layout><Home /></Layout>} />

    {/* About */}
    <Route path='/about' element={<Layout><About /></Layout>} />

    {/* Services */}
    <Route path='/services' element={<Layout><Services /></Layout>} />

    {/* Contact */}
    <Route path='/contact' element={<Layout><Contact /></Layout>} />
    <Route path='/feedback/:type' element={<Layout><FeedbackSurvey /></Layout>} />

    {/* App download / invitation pages */}
    <Route path='/download' element={<Layout><DownloadApps /></Layout>} />
    <Route path='/download/:app' element={<Layout><DownloadApps /></Layout>} />

    {/* Policies */}
    <Route path='/terms-and-conditions' element={<Layout><TermsAndConditions /></Layout>} />
      <Route path='/privacy-policy' element={<Layout><PrivacyPolicy /></Layout>} />
    <Route path='/index.html' element={<LegacyIndexRoute />} />
    <Route path='/refund-policy' element={<Layout><RefundPolicy /></Layout>} />
    <Route path='/desclaimer' element={<Layout><Desclaimer /></Layout>} />

    {/* Old /ksdpl routes redirect to new routes */}
    <Route path='/ksdpl' element={<Navigate to='/' replace />} />
    <Route path='/ksdpl/about' element={<Navigate to='/about' replace />} />
    <Route path='/ksdpl/services' element={<Navigate to='/services' replace />} />
    <Route path='/ksdpl/contact' element={<Navigate to='/contact' replace />} />
    <Route path='/ksdpl/feedback/:type' element={<Navigate to='/feedback/:type' replace />} />
    <Route path='/ksdpl/terms-and-conditions' element={<Navigate to='/terms-and-conditions' replace />} />
    <Route path='/ksdpl/privacy-policy' element={<Navigate to='/privacy-policy' replace />} />
    <Route path='/ksdpl/refund-policy' element={<Navigate to='/refund-policy' replace />} />
    <Route path='/ksdpl/desclaimer' element={<Navigate to='/desclaimer' replace />} />

    {/* fallback route */}
    <Route path="*" element={<NotFound />} />
</Routes>

        </BrowserRouter>
    );
};

export default App;